import React, { ReactElement } from 'react';
import { UserContext } from '../../core/context/UserContext';
import styles from './AppUserMenu.module.less';
import UserMenu from './UserMenu';

interface Props {}

function AppUserMenu({}: Props): ReactElement {
    return (
        <div className={styles.AppUserMenu}>
            <UserContext.Consumer>
                {({ user: value }) => <UserMenu user={value} />}
            </UserContext.Consumer>
        </div>
    );
}

export default AppUserMenu;
